import { qs } from "../../lib/api/endpoints";

export const productPath = ({ productId, volume, radiusKm, coordinates, containerOptionId }) =>
  `/products${productId ? `/${productId}` : ""}${qs({
    volume,
    radius: radiusKm,
    option: containerOptionId,
    lat: coordinates?.latitude,
    lng: coordinates?.longitude,
  })}`;

export const supplierPath = ({ supplierId, distanceKm, radiusKm, coordinates }) =>
  `/suppliers/${supplierId}${qs({
    distance: Number.isFinite(distanceKm) && distanceKm > 0 ? distanceKm.toFixed(3) : null,
    radius: radiusKm,
    lat: coordinates?.latitude,
    lng: coordinates?.longitude,
  })}`;

export const supplierProductPath = ({ supplierId, productId, coordinates }) =>
  `/suppliers/${supplierId}/products/${productId}${qs({
    lat: coordinates?.latitude,
    lng: coordinates?.longitude,
  })}`;

export const CART_PATH = "/my-cart";
